import { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { PrimaryButton } from '../components/Buttons';
import { LogoMark } from '../components/Logo';

export default function FinalCta({ onStart }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end end'] });
  const rotate = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [-18, 0]);
  const scale = useTransform(scrollYProgress, [0, 1], reduce ? [1, 1] : [0.8, 1]);
  const opacity = useTransform(scrollYProgress, [0.2, 0.8], reduce ? [1, 1] : [0, 1]);

  return (
    <section ref={ref} aria-label="Get started" className="relative mx-auto max-w-[1480px] px-4 py-28 sm:px-6 tall:px-12 land:py-40">
      <motion.div aria-hidden="true" style={{ rotate, scale, opacity }} className="pointer-events-none absolute -right-[8%] top-1/2 -translate-y-1/2 text-pn-fg/[0.06] land:right-[4%]">
        <LogoMark className="h-[44vmin] w-[44vmin]" title="" />
      </motion.div>
      <motion.div style={{ opacity }} className="relative">
        <h2 className="pn-display max-w-[11ch]">Upload tonight&rsquo;s log.</h2>
        <p className="pn-lede mt-6">Free to start. Your first breakdown is one upload away.</p>
        <PrimaryButton onClick={onStart} className="mt-10 text-[clamp(1rem,0.85rem+0.5*var(--u),1.2rem)]">Start free</PrimaryButton>
      </motion.div>
    </section>
  );
}
